import { Ticket } from "lucide-react";
import "./PublicSplashScreen.scss";

export default function PublicSplashScreen({
  title = "Memuat Event",
  subtitle = "Mohon tunggu sebentar…",
}) {
  return (
    <div className="public-splash">
      <div className="public-splash__content">
        <div className="public-splash__logo">
          <Ticket size={34} strokeWidth={2.2} />
        </div>

        <h2>{title}</h2>
        <p>{subtitle}</p>

        <div className="public-splash__loader">
          <span />
        </div>
      </div>
    </div>
  );
}